import { useAtomValue } from 'jotai';
import { userInfoAtom } from '../data/atoms/utilsAtoms';
import { useEffect } from 'react';
import { getAllTrackingIds, getFPTid, persistMetaCookiesToStorage } from '@/utils/metaCookies'; // NEW IMPORT

const getAnalyticsUserDetails = user => {
	if (!user) {
		return null;
	}

	const { firstname, lastname, email, _id, userType } = user;
	const normalizedEmail = typeof email === 'string' ? email.toLowerCase() : '';
	const fallbackCustomerId = normalizedEmail || _id?.toString() || '';

	if (!fallbackCustomerId) {
		return null;
	}

	return {
		firstname,
		lastname,
		normalizedEmail,
		fallbackCustomerId,
		userId: _id?.toString() || '',
		userType
	};
};

export const useAnalytics = () => {
	const userData = useAtomValue(userInfoAtom);

	useEffect(() => {
		const analyticsUser = getAnalyticsUserDetails(userData.user);

		if (!analyticsUser || typeof window === 'undefined') {
			return;
		}

		if (typeof window.clarity === 'function') {
			window.clarity('identify', analyticsUser.normalizedEmail || analyticsUser.userId);
		}
	}, [userData.user]);

	useEffect(() => {
		const analyticsUser = getAnalyticsUserDetails(userData.user);

		if (!analyticsUser) {
			return;
		}

		if (typeof window !== 'undefined') {
			window.getFPTid = getFPTid;
		}

		if (typeof window === 'undefined' || !window.Chargebee?.init) {
			return;
		}

		// Initialize Chargebee
		window.Chargebee.init({
			site: import.meta.env.VITE_CHARGEBEE_SITE,
			publishableKey: import.meta.env.VITE_APP_CHARGEBEE_API_KEY,
			enableRefersionTracking: true
		});

		window.Chargebee.registerAgain();
		const testInstance = window.Chargebee.getInstance();
		const cart = testInstance.getCart();

		// Build base customer details
		const customerDetails = {
			id: analyticsUser.fallbackCustomerId,
			email: analyticsUser.fallbackCustomerId,
			first_name: analyticsUser.firstname,
			last_name: analyticsUser.lastname
		};

		// Handle studio owner ID suffix
		if (analyticsUser.userType === 'studio-owner') {
			customerDetails.id = `${analyticsUser.fallbackCustomerId}-studio`;
		}

		const trackingIds = getAllTrackingIds();

		// Merge tracking IDs into customer details
		Object.assign(customerDetails, trackingIds);

		// Set customer on cart
		cart.setCustomer(customerDetails);

		persistMetaCookiesToStorage();
	}, [userData.user, userData.token]);
};
